import React from 'react'
import { vulnerabilitiesTableColumns } from './Columns';
import Table from 'UI/Table'

const VulnerabilitiesAccordionTable = ({ vulnerabilities }) => {
  const columns = [
    {
      Header: 'CVE Name',
      accessor: 'cve_name',
      Cell: row => (<a href={row.original.cve_url} target="_blank">{row.original.cve_name}</a>)
    },
    ...vulnerabilitiesTableColumns
  ]
  return (
    <Table data={vulnerabilities} columns={columns} filterable />
  )
}

export default VulnerabilitiesAccordionTable
